.partner_Partner_b8bd5df{fill:var(--pencil-color)}